// extracted by mini-css-extract-plugin
module.exports = {"MysqlDbCompareDashboard":"MysqlDbCompareDashboard_gOzy2"};